import { AppEndpoint } from "app/app.endpoints";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ToastrService } from "ngx-toastr";

import { HttpRequestService } from "app/auth/service/http-request.service";
import { AuthenticationService } from "./authentication.service";
import { getDefaultPermission, UserRules } from "../models/user-rules";
import { defaultMenu as menu } from "app/menu/menu";
import { CoreMenu } from "@core/types";
import {
  MenuByRole,
  modulesByRole,
  PermissionModules,
} from "../helpers/menu.helper";
import { UserAcl } from "../models/acl.type";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class PermissionService {
  private url = AppEndpoint.BASE_URL + "/private" + "/permissions";

  public currentPermissions: BehaviorSubject<PermissionModules> =
    new BehaviorSubject<any>({});
  private routeIndexModules = {
    "clientes/admin/agregar": "admin",
  };
  private modulesPermissions: MenuByRole = modulesByRole;

  constructor(
    private _http: HttpRequestService,
    private http: HttpClient,
    private _toastr: ToastrService,
    private _auth: AuthenticationService
  ) {
    menu.forEach((curr: CoreMenu) => {
      if (curr.url) this.routeIndexModules[curr.url] = curr.module;
      if (curr.children) {
        curr.children.forEach((curr2: CoreMenu) => {
          if (curr2.url) this.routeIndexModules[curr2.url] = curr.module;
        });
      }
    });
  }

  createPermission = (permissionData): Observable<any> =>
    this.http.post(`${this.url}/create`, permissionData);

  createOrUpdateAcl = (userId: number, fields: UserAcl): Observable<any> =>
    this.http.post(`${this.url}/create-update-acl/${userId}`, fields).pipe(
      map((response: any) => {
        this._toastr.success("Permisos establecidos");
        return response;
      }),
      catchError((error: any) => {
        console.error("Error al crear/actualizar acl", error);
        throw error;
      })
    );

  updatePermission = (permissionId, permissionData): Observable<any> =>
    this.http.put(`${this.url}/update/${permissionId}`, permissionData);

  getById = (permissionId: string): Observable<any> =>
    this._http.Permission(this.companyId, permissionId).get();

  // * ---------------------------- PERMISSION HELPERS CONTROL ------------------------------
  /* setPermission = (): any => {
    const id = this._auth.permissionId;
    if (id) {
      this.default = false;
      console.warn("PERMISOS NO POR DE DEFECTO");
      this.getById(id).subscribe((response: UserRules) => {
        this.currentPermissions.next(
          response ? response : getDefaultPermission()
        );
      });
    } else {
      this.default = true;
      console.warn("PERMISOS POR DE DEFECTO");
      this.currentPermissions.next(getDefaultPermission());
    }
  }; */

  setUserPermission = (modules: PermissionModules): any => {
    console.log("TO SET CURRENT PERMISSIONS", modules);
    this.currentPermissions.next(modules);
  };

  hasAccess = (url: string): boolean => {
    const ignorePaths = ["reportes/detalles"];
    if (ignorePaths.includes(url)) return true;
    const module = this.routeIndex[url];
    if (module === "dashboard") return true;

    if (!module) console.error("Ruta no tiene un modulo", url);
    if (!module) return false; // todo
    // if (!module) return true;
    const moduleMenu = this.modules[module];
    console.log(
      "Module menu",
      module,
      moduleMenu,
      this._auth.role,
      this.permissions
    );
    let canAccess = moduleMenu?.roleAccess?.includes(this._auth.role);
    if (this.permissions) {
      canAccess = canAccess && !!this.permissions[module]?.access;
    }
    // console.log("Has access", module, this.modules, this.permissions);
    return canAccess;
  };

  get routeIndex() {
    return this.routeIndexModules;
  }

  get permissions() {
    return this.currentPermissions.value;
  }

  get modules() {
    return this.modulesPermissions;
  }

  get companyId() {
    return this._auth.companyId;
  }

  get userId() {
    return this._auth.userId;
  }
}
